module.exports = __webpack_public_path__ + "static/media/TouchflowPC for Android.c72774e8.msi";